var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearSearchTabletView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.017,
    height: 54.017,
    viewBox: "0 0 54.017 54.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7909",
    x: 0,
    y: 0,
    width: 54.017,
    height: 54.017,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29984",
    "data-name": "Group 29984",
    transform: "translate(-277.245 -887.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28069",
    "data-name": "Group 28069",
    transform: "translate(286.245 893.672)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#Rectangle_7909)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7909-2",
    "data-name": "Rectangle 7909",
    width: 36.017,
    height: 36.017,
    rx: 7,
    transform: "translate(9 6)",
    fill: "#ff8000",
    opacity: 0.795
  }))), /*#__PURE__*/React.createElement("g", {
    id: "backspace_black_24dp",
    transform: "translate(290.914 899.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17438",
    "data-name": "Path 17438",
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17439",
    "data-name": "Path 17439",
    d: "M22,3H7a1.882,1.882,0,0,0-1.59.88L0,12l5.41,8.11A1.891,1.891,0,0,0,7,21H22a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,22,3Zm0,16H7.07L2.4,12,7.06,5H22ZM10.41,17,14,13.41,17.59,17,19,15.59,15.41,12,19,8.41,17.59,7,14,10.59,10.41,7,9,8.41,12.59,12,9,15.59Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearSearchTabletView);
export default __webpack_public_path__ + "static/media/clearSearch-tabletView.b9de419d3bef24e38f214f5de04149ca.svg";
export { ForwardRef as ReactComponent };